export default "__VITE_ASSET__CrjBZHAn__"